import { useState, useRef, useCallback, useEffect } from 'react';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';

const IDLE_TIMEOUT = 5000;

const useIdleTimeout = (isIdleShouldBeEnabled = true) => {
  const [idle, setIdle] = useState(false);
  const [isMousePressed, setIsMousePressed] = useState(false);
  const timeoutRef = useRef(null);

  const startIdleTimeout = useCallback(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIdle(true);
      SpatialNavigationWrapper.pauseNavigation();
    }, IDLE_TIMEOUT);

    if (idle) {
      setIdle(false);
      setTimeout(() => SpatialNavigationWrapper.resumeNavigation(), 0);
    }
  }, [idle]);

  const stopIdleTimeout = useCallback(() => clearTimeout(timeoutRef.current), []);

  useEffect(() => {
    if (!isIdleShouldBeEnabled) stopIdleTimeout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIdleShouldBeEnabled]);

  useEffect(() => {
    const onKeydown = () => startIdleTimeout();

    const onMouseDown = () => {
      setIsMousePressed(true);
      stopIdleTimeout();
    };

    const onMouseUp = () => {
      setIsMousePressed(false);
      if (isIdleShouldBeEnabled) startIdleTimeout();
    };

    const onMousemove = (e) => {
      e.preventDefault();
      if (isIdleShouldBeEnabled && !isMousePressed) startIdleTimeout();
    };

    document.body.addEventListener('keydown', onKeydown, true);
    document.body.addEventListener('mousedown', onMouseDown, true);
    document.body.addEventListener('mouseup', onMouseUp, true);
    document.body.addEventListener('mousemove', onMousemove, true);

    return () => {
      document.body.removeEventListener('keydown', onKeydown, true);
      document.body.removeEventListener('mousedown', onMouseDown, true);
      document.body.removeEventListener('mouseup', onMouseUp, true);
      document.body.removeEventListener('mousemove', onMousemove, true);
    };
  }, [isIdleShouldBeEnabled, isMousePressed, startIdleTimeout, stopIdleTimeout]);

  useEffect(() => {
    startIdleTimeout();

    SpatialNavigationWrapper.focus(); // STVWL-136 - Fix default focus on video player

    return () => {
      stopIdleTimeout();
      // In some cases navigation could be disable after exit from player
      // This line is fixed it
      SpatialNavigationWrapper.resumeNavigation();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return idle;
};

export default useIdleTimeout;
